import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** A Move Back from Delivery Scheduling clears the scheduled delivery, as does the auto-path one from Ready to Deliver and every Failed Delivery. */
export function salesOrderRevertClearsSchedule({ statusId, readyToDeliverMode, failedDelivery, }) {
    if (failedDelivery)
        return true;
    if (statusId === SalesOrderStatus.DELIVERY_SCHEDULING)
        return true;
    return statusId === SalesOrderStatus.READY_TO_DELIVER && readyToDeliverMode === 'auto';
}
//# sourceMappingURL=sales-order-revert-clears-schedule.js.map